import { render, staticRenderFns } from "./orderRecord.vue?vue&type=template&id=8985cd64&scoped=true"
import script from "./orderRecord.vue?vue&type=script&lang=js"
export * from "./orderRecord.vue?vue&type=script&lang=js"
import style0 from "./orderRecord.vue?vue&type=style&index=0&id=8985cd64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8985cd64",
  null
  
)

export default component.exports